import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GoogleIntegrationService } from 'src/app/services/google-integration.service';
import { FrontendLoggerService } from 'src/app/services/frontend-logger.service';

@Component({
  selector: 'app-google-callback',
  templateUrl: './google-callback.component.html',
  styleUrls: ['./google-callback.component.scss'],
  standalone: false
})
export class GoogleCallbackComponent implements OnInit {
  isLoading = true;
  errorMessage = '';
  successMessage = '';

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly googleIntegrationService: GoogleIntegrationService,
    private readonly frontendLogger: FrontendLoggerService
  ) {}

  ngOnInit(): void {
    // Leer los parámetros code/scope de la URL y trazar en consola
    this.route.queryParams.subscribe(params => {
      const code = params['code'];
      const scope = params['scope'];
      const state = params['state'];
      const redirectUri = `${globalThis.location?.origin ?? ''}/callback`;
      this.frontendLogger.info(`[GoogleCallbackComponent] OAuth callback recibido. isPopup=${!!globalThis.opener}`);

      if (code) {
        this.frontendLogger.info('[GoogleCallbackComponent] Intercambiando code por token...');
        this.googleIntegrationService.exchangeCodeForToken(code, scope, state, redirectUri).subscribe({
          next: () => {
            this.frontendLogger.info('[GoogleCallbackComponent] exchangeCodeForToken OK');
            this.isLoading = false;
            this.successMessage = 'Conexión exitosa con Google.';
            // Cierra el popup si está en uno
            if (globalThis.opener) {
              try {
                globalThis.opener.postMessage({ source: 'google-oauth', status: 'success' }, globalThis.location?.origin ?? '');
              } catch (postErr) {
                this.frontendLogger.error(`[GoogleCallbackComponent] postMessage falló: ${String(postErr)}`);
              }
              this.frontendLogger.info('[GoogleCallbackComponent] Cerrando ventana popup');
              globalThis.close();
            } else {
              // Redirige a settings si no está en popup
              this.frontendLogger.info('[GoogleCallbackComponent] Redirigiendo a /admin/settings');
              this.router.navigate(['/admin/settings']);
            }
          },
          error: (err) => {
            const status = err?.status ?? 'unknown';
            this.frontendLogger.error(`[GoogleCallbackComponent] exchangeCodeForToken ERROR status=${status}`);
            this.isLoading = false;
            const backendMsg = err?.error?.message || err?.message || '';
            this.errorMessage = backendMsg ? `Error al conectar con Google: ${backendMsg}` : 'Error al conectar con Google.';
            // Notifica al padre y cierra el popup también en error para no dejarlo abierto indefinidamente
            if (globalThis.opener) {
              try {
                globalThis.opener.postMessage({ source: 'google-oauth', status: 'error', message: backendMsg }, globalThis.location?.origin ?? '');
              } catch (postErr) {
                this.frontendLogger.error(`[GoogleCallbackComponent] postMessage (error) falló: ${String(postErr)}`);
              }
              this.frontendLogger.info('[GoogleCallbackComponent] Cerrando ventana popup por error');
              globalThis.close();
            } else {
              // Si no es popup, navegar mostrando error en settings (opcionalmente con query)
              this.router.navigate(['/admin/settings']);
            }
          }
        });
      } else {
        this.frontendLogger.error('[GoogleCallbackComponent] Falta parámetro code en la URL');
        this.isLoading = false;
        this.errorMessage = 'No se recibió el código de autorización.';
      }
    });
  }
}
